const winRouters = [
  // 个人签名
  {
    path: '/canvasName',
    name: 'CanvasName',
    icon: 'el-icon-goods',
    keepalive: true,
    hidden: true,
    component: () => import('@/pages/file/canvasName.vue')
  },

  // 迭代五期 AT 指令
  {
    icon: 'el-icon-s-order',
    name: 'ATInstruction',
    path: '/atinstruction',
    hidden: true,
    component: () =>
      import('@/pages/equipment/gateway/components/ATInstruction.vue')
  },
  // 监测点详细
  {
    path: '/newCarrierDetail',
    name: 'NewCarrierDetail',
    icon: '',
    hidden: true,
    meta: { win: true },
    component: () => import('@/pages/business/components/detail/DetailNew.vue')
  },
  // 传感器 历史数据
  {
    path: '/historyData',
    name: 'historyData',
    icon: 'el-icon-goods',
    keepalive: true,
    hidden: true,
    // 不需要经过拦截设置window title
    meta: { windowTitle: true },

    component: () => import('@/pages/equipment/sensor/echart/Echart.vue')
  },
  // 监测点详细下传感器 的表格详细
  {
    path: '/SensorDetail',
    name: 'SensorDetail',
    hidden: true,
    component: () =>
      import('@/components/dialog/sensorDetail/sensorDetailDialogWin.vue')
  },
  // 监测点详细下网关 的表格详细
  {
    path: '/GateWayDetail',
    name: 'GateWayDetail',
    hidden: true,
    component: () =>
      import('@/components/dialog/gatewayDetail/gatewayDetailDialogWin.vue')
  },
  // 监测点详细下显示屏的表格详情 window
  {
    path: '/DisplayDetail',
    name: 'DisplayDetail',
    icon: '',
    hidden: true,
    component: () =>
      import('@/components/dialog/displayDetail/displayDetailDialogWin.vue')
  },
  // 监测点详细下中继的详情
  {
    path: '/RelayDetail',
    name: 'RelayDetail',
    icon: '',
    hidden: true,
    component: () =>
      import('@/components/dialog/relayDetail/relayDetailDialogWin.vue')
  },
  // 底座详情 Win
  {
    path: '/BaseDetail',
    name: 'BaseDetail',
    icon: '',
    hidden: true,
    meta: { win: true },
    component: () =>
      import('@/components/dialog/baseDetail/baseDetailDialogWin.vue')
  },
  // 异常记录点  window
  {
    path: '/pointData',
    name: 'pointData',
    icon: '',
    hidden: true,
    component: () => import('@/pages/business/components/detail/pointData.vue')
  },
  // 监测点下的操作记录  window
  {
    path: '/OperateRecord',
    name: 'OperateRecord',
    icon: '',
    hidden: true,
    component: () =>
      import('@/pages/business/components/operateRecord/OperateRecord.vue')
  },
  // 监测点详细可追踪按钮
  {
    path: '/platInfer',
    name: 'platInfer',
    hidden: true,
    component: () => import('@/pages/monitoring/platInferHome.vue')
  },
  // 平面图 win
  {
    path: '/plan',
    name: 'plan',
    hidden: true,
    component: () => import('@/pages/home/component/Map/Plan.vue')
  },
  // 设备监控 弹窗win
  {
    path: '/datadevice',
    name: 'dataDevice',
    hidden: true,
    meta: { windowTitle: true },
    component: () =>
      import('@/pages/dataBoard/deviceMonitor/deviceReal/win/Win.vue')
  },
  // 监测点实时情况 win
  {
    path: '/monitorPointRealTime',
    name: 'monitorPointRealTime',
    hidden: true,
    component: () =>
      import('@/pages/dataBoard/MonitoringPoint/win/MonitorPointRealTime.vue')
  },
  // 异常记录 win
  {
    path: '/exRecord',
    name: 'exRecord',
    hidden: true,
    component: () =>
      import('@/pages/dataBoard/MonitoringPoint/win/exRecord.vue')
  },
  // 采集数据 win
  {
    path: '/sampleData',
    name: 'sampleData',
    hidden: true,
    component: () =>
      import('@/pages/dataBoard/MonitoringPoint/win/sampleData.vue')
  },
  // 监测点属性列表 win
  {
    path: '/propertyList',
    name: 'propertyList',
    hidden: true,
    component: () =>
      import('@/pages/dataBoard/MonitoringPoint/win/PropertyList.vue')
  },
  // 监测点详细可追踪按钮
  {
    path: '/traceDetail',
    name: 'traceDetail',
    hidden: true,
    component: () => import('@/pages/dataBoard/mapMonitor/win/traceDetail')
  },
  // 探头历史(单个探头)
  {
    path: '/probeHistory',
    name: 'probeHistory',
    hidden: true,
    component: () =>
      import('@/pages/business/win/ProbeHistory/ProbeHistory.vue')
  },
  // 挂载探头历史(挂载下的所有探头)
  {
    path: '/carrierProbeHistory',
    name: 'carrierProbeHistory',
    component: () =>
      import('@/pages/business/win/CarrierProbeHistory/CompareHistory.vue'),
    hidden: true,
    props: true
  },
  // 运输模式历史
  {
    path: '/transHistory',
    name: 'transHistory',
    component: () =>
      import('@/pages/business/win/TransportHistory/TransportHisotry.vue'),
    hidden: true
  },
  {
    path: '/baseHistory',
    name: 'baseHistory',
    component: () =>
      import('@/pages/equipment/base/win/BaseHistory/BaseHistory.vue')
  },
  // 报警触发
  {
    name: 'alarmTrigger',
    path: '/sysAlarm',
    component: () => import('@/pages/applied/sysalarm/sysAlarm.vue')
  },
  // 异常详情弹窗 不需要校验身份
  {
    name: 'exDetail',
    path: '/exDetail',
    meta: { noAuth: true },
    component: () => import('@/pages/abnormal/win/ExDetail/ExDetail.vue')
  },
  // 数据备份
  {
    name: 'dataBackup',
    path: '/dataBackup',
    meta: { noAuth: true },
    component: () => import('@/pages/win/DataBackup/DataBackup.vue')
  },
  // App 下载（免登录，根据 param_content 配置自动跳转）
  {
    name: 'appDownloadAndroid',
    path: '/app/a',
    meta: { noAuth: true },
    component: () => import('@/pages/app/download.vue')
  },
  {
    name: 'appDownloadIOS',
    path: '/app/o',
    meta: { noAuth: true },
    component: () => import('@/pages/app/download.vue')
  },
  // 监测点详细下气体的表格详细
  {
    path: '/GasDetail',
    name: 'GasDetail',
    hidden: true,
    component: () =>
      import('@/components/dialog/gasDetail/gasDetailDialogWin.vue')
  },
]

export default winRouters
